import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';
import validate from './validate';
import {renderField, renderHidden} from '../../../utils/renderFields';
import { sendPasswordReset, clearResetToken } from '../../../actions/auth';

const propTypes = {
  initialValues: PropTypes.object,
  closeModal: PropTypes.func,
}

const defaultProps = {
  initialValues: {
    uid: null,
    token: null,
  },
  closeModal: () => {},
}

class PasswordResetForm extends React.Component {

  constructor(props){
    super(props);
    this.submit = this.submit.bind(this);
    this.afterSuccess = this.afterSuccess.bind(this);
  }

  afterSuccess() {
    setTimeout(function(){
      this.props.dispatch(clearResetToken());
      this.props.closeModal();
    }.bind(this), 3000);
  }

  submit(values) {
    return this.props.dispatch(sendPasswordReset(values, this.afterSuccess));
  }

  render(){
    const { error, handleSubmit, submitting, submitSucceeded } = this.props;
    if(submitSucceeded) {
      return (
        <div className="text-center">
          <p>Your password has been successfully reset! You can now login with your new password.</p>
        </div>
      );
    }
    return(
      <div className="p-20">
        <p>Enter a new password below to reset your password.</p>

        <form onSubmit={handleSubmit(this.submit)}>
          <span className="u-fontSize-11">{error}</span>
          <Field component={renderField} name="email" type="email" label="Email" className="form-control" />
          <Field component={renderField} name="password" type="password" label="Password" className="form-control"/>
          <Field component={renderField} name="passwordConfirm" type="password" label="Re-type Password" className="form-control"/>
          <Field component={renderHidden} name="token" />
          <input type="submit" value="Submit" className="btn btn-primary" disabled={submitting} />
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {
      token: state.auth.resetPassword.token,
    },
    closeModal: ownProps.closeModal,
  };
}

PasswordResetForm = reduxForm({form:'forgot-password', validate, fields:['password'], enableReinitialize:true})(PasswordResetForm);

PasswordResetForm.propTypes = propTypes;
PasswordResetForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(PasswordResetForm);
